import * as React from "react";

import { ILeanSvgIcon } from "../ILeanSvgIcon";

export const powerpoint: React.FunctionComponent<ILeanSvgIcon> = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...rest}>
      <defs id="defs32" />
      <path
        fill="#ed6c47"
        d="M 14.511629,13.183203 12.837211,0.90413281 H 12.712183 C 6.6235726,0.92190831 1.6921941,5.8532867 1.6744189,11.941895 v 0.125029 z"
        id="path4"
        strokeWidth={0.0125004}
      />
      <path
        fill="#ff8f6b"
        d="M 12.96224,0.90413281 H 12.837211 V 12.066924 L 18.418607,14.299481 24,12.066924 V 11.941895 C 23.982224,5.8532867 19.050843,0.92190831 12.96224,0.90413281 Z"
        id="path6"
        strokeWidth={0.0125004}
      />
      <path
        fill="#d35230"
        d="m 24,12.066924 v 0.122791 c -0.01749,6.08997 -4.95003,11.022524 -11.04,11.039999 H 12.714417 C 6.6244473,23.212239 1.6918937,18.279685 1.6744189,12.189715 v -0.122791 z"
        id="path8"
        strokeWidth={0.0125004}
      />

      <path
        opacity="0.2"
        enableBackground="new    "
        d="M 12.837211,6.9487902 V 17.743209 c -0.0044,0.562328 -0.459067,1.017139 -1.021394,1.021402 H 3.8623258 C 2.4403512,16.867699 1.6725688,14.560439 1.6744189,12.189727 V 11.944145 C 1.671156,9.8058148 2.2960971,7.7136226 3.471628,5.9274011 h 8.344177 c 0.562339,0.00424 1.017152,0.4590495 1.021406,1.0213891 z"
        id="path14"
        fillOpacity={0.4}
        strokeWidth={0.0125004}
      />

      <linearGradient
        id="SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1="170.6454"
        y1="1450.1008"
        x2="811.65472"
        y2="339.8992"
        gradientTransform="matrix(0.01250035,0,0,-0.01250033,0,23.254716)"
      >
        <stop offset="0" stopColor="#CA4C28" id="stop18" />
        <stop offset="0.5" stopColor="#C5401E" id="stop20" />
        <stop offset="1" stopColor="#B62F14" id="stop22" />
      </linearGradient>
      <path
        fill="url(#SVGID_1_)"
        d="M 1.0230639,5.9273886 H 11.255993 c 0.565028,0 1.023062,0.4580495 1.023062,1.0230641 V 17.183382 c 0,0.565027 -0.458046,1.023076 -1.023062,1.023076 H 1.0230639 C 0.45804942,18.206458 0,17.748409 0,17.183395 V 6.9504527 C 0,6.3854381 0.45804942,5.9273886 1.0230639,5.9273886 Z"
        id="path25"
        strokeWidth={0.0125004}
      />
      <path
        fill="#ffffff"
        d="m 6.2511629,8.6561347 c 0.6661294,-0.044951 1.3265218,0.1485413 1.8630734,0.5458641 0.4475117,0.399523 0.6866302,0.9825132 0.6485544,1.5812042 0.00731,0.416185 -0.1035902,0.825909 -0.3198085,1.18158 -0.2189057,0.34956 -0.5342889,0.628304 -0.9080982,0.802609 -0.4273488,0.198755 -0.8945739,0.296895 -1.3657731,0.286882 H 4.8747896 V 15.45985 H 3.5492046 V 8.6561347 Z M 4.8736768,12.015022 h 1.1408423 c 0.3616718,0.02657 0.7205312,-0.08048 1.008564,-0.300833 0.2382308,-0.22853 0.3630969,-0.550802 0.341021,-0.880185 0,-0.74977 -0.435724,-1.1246542 -1.3071591,-1.1246542 H 4.8736896 v 2.3056722 z"
        id="path27"
        strokeWidth={0.0125004}
      />
    </svg>
  );
};
